import * as Mod1 from "./discourse/components/post-menu/toggle-translation-button";
import * as Mod2 from "./discourse/components/translated-post-indicator";
import * as Mod3 from "./discourse/components/translated-post";
import * as Mod4 from "./discourse/initializers/extend-for-translate-button";
import * as Mod5 from "./discourse/services/translator";
const compatModules = {
  "discourse/components/post-menu/toggle-translation-button": Mod1,
  "discourse/components/translated-post-indicator": Mod2,
  "discourse/components/translated-post": Mod3,
  "discourse/initializers/extend-for-translate-button": Mod4,
  "discourse/services/translator": Mod5,
};
export default compatModules;
